import React, { useCallback } from 'react';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Link, useHistory } from 'react-router-dom';

import checkPassword from 'shared/no-auth/components/AccountEditor/checkPassword';
import Form, { PasswordField, Submit } from '../../containers/form';
import Auth from '..';
import {
  Root, LogoImage, RedAstreriks,
  StyledCard, StyledCardHeader, StyledCardActions,
} from './styled';


const initialValues = {
  password: '',
  password2: '',
};

export default function SetNewPassword({ match: { params: { email, code } } }) {
  const { push } = useHistory();
  const handleSubmit = useCallback(async ({ password, password2 }) => {
    try {
      if (password !== password2) {
        alert('Passwords must match!');
        return false;
      }
      if (!checkPassword(password)) {
        return false;
      }
      await Auth.forgotPasswordSubmit(email, code, password);
      alert('Password reset successfully!');
      push('/login');
    } catch (e) {
      alert(e.message || e);
      return false;
    }
  }, [push]);

  return (
    <Root>
      <LogoImage/>
      <Form
        {...{ initialValues }}
        onSubmit={handleSubmit}
      >
        <StyledCard>
          <StyledCardHeader
            title="Set a New Password"
            subheader={`for ${email}`}
          />
          <CardContent>
            <PasswordField
              name="password"
              label="New Password"
              fullWidth
              required
            />
            <PasswordField
              name="password2"
              label="Confirm New Password"
              fullWidth
              required
            />
            <br/><br/>
            <Typography
              component="div"
              varuant="body2"
              color="textSecondary"
            >
              Fields marked with <RedAstreriks/> are mandatory
            </Typography>
            <Typography
              component="div"
              varuant="body2"
              color="textSecondary"
            >
              Back to <Link to="/login">Login</Link>
            </Typography>
          </CardContent>
          <StyledCardActions>
            <Submit
              variant="contained"
              color="primary"
            >
              Set New Password
            </Submit>
          </StyledCardActions>
        </StyledCard>
      </Form>
    </Root>
  );
}
